import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./TroubleshootingPage'),
  loading: () => <Loading />,
});
